/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from 'ethers'
import { Provider, TransactionRequest } from '@ethersproject/providers'
import { Contract, ContractFactory, Overrides } from '@ethersproject/contracts'

import type { PredyMathTester } from '../PredyMathTester'

export class PredyMathTester__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer)
  }

  deploy(overrides?: Overrides): Promise<PredyMathTester> {
    return super.deploy(overrides || {}) as Promise<PredyMathTester>
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {})
  }
  attach(address: string): PredyMathTester {
    return super.attach(address) as PredyMathTester
  }
  connect(signer: Signer): PredyMathTester__factory {
    return super.connect(signer) as PredyMathTester__factory
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): PredyMathTester {
    return new Contract(address, _abi, signerOrProvider) as PredyMathTester
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: 'int128',
        name: 'x',
        type: 'int128'
      }
    ],
    name: 'testAbs',
    outputs: [
      {
        internalType: 'uint128',
        name: '',
        type: 'uint128'
      }
    ],
    stateMutability: 'pure',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint64',
        name: '_x',
        type: 'uint64'
      },
      {
        internalType: 'uint64',
        name: '_d',
        type: 'uint64'
      },
      {
        internalType: 'bool',
        name: '_roundUp',
        type: 'bool'
      }
    ],
    name: 'testDiv64',
    outputs: [
      {
        internalType: 'uint64',
        name: '',
        type: 'uint64'
      }
    ],
    stateMutability: 'pure',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint128',
        name: 'a',
        type: 'uint128'
      },
      {
        internalType: 'uint128',
        name: 'b',
        type: 'uint128'
      }
    ],
    name: 'testMax',
    outputs: [
      {
        internalType: 'uint128',
        name: '',
        type: 'uint128'
      }
    ],
    stateMutability: 'pure',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint128',
        name: 'a',
        type: 'uint128'
      },
      {
        internalType: 'uint128',
        name: 'b',
        type: 'uint128'
      }
    ],
    name: 'testMin',
    outputs: [
      {
        internalType: 'uint128',
        name: '',
        type: 'uint128'
      }
    ],
    stateMutability: 'pure',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint128',
        name: '_x',
        type: 'uint128'
      },
      {
        internalType: 'uint128',
        name: '_y',
        type: 'uint128'
      },
      {
        internalType: 'uint128',
        name: '_d',
        type: 'uint128'
      },
      {
        internalType: 'bool',
        name: '_roundUp',
        type: 'bool'
      }
    ],
    name: 'testMulDiv',
    outputs: [
      {
        internalType: 'uint128',
        name: '',
        type: 'uint128'
      }
    ],
    stateMutability: 'pure',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_a',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_from',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_to',
        type: 'uint256'
      }
    ],
    name: 'testScale',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'pure',
    type: 'function'
  }
]

const _bytecode =
  '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'
